
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.375.898C6.792 3.56 5.56 5.891 4.68 7.891c.052.546.078 1.174.078 1.882 0 .35-.01.654-.031.915l-.704.445H3.22v-.492c0-.865.177-1.709.531-2.532-.188-1.895-.508-3.52-.96-4.875-.454-1.354-.941-2.03-1.462-2.03-.172 0-.411.111-.719.335l-.32-.453C.9.606 1.443.367 1.922.367c.74 0 1.325.505 1.758 1.516.437 1.005.721 2.515.851 4.531h.094c1.104-2.667 1.83-4.633 2.18-5.898h1.57v.382z","fill":"currentColor"}})])
          )
        }
      }
    